(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.headerResizeObserver = new ResizeObserver(() => this.setHeaderHeight());
      this.headerResizeObserver.observe(this.header);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.headerResizeObserver?.disconnect();
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  function positionAccountDialog(account) {
    const bounds = account.getBoundingClientRect();
    const viewportBounds = document.documentElement.getBoundingClientRect();
    const inlineEnd = getComputedStyle(account).direction === 'rtl'
      ? bounds.left - viewportBounds.left
      : viewportBounds.right - bounds.right;

    account.style.setProperty('--account-dialog-top', `${Math.max(0, Math.round(bounds.bottom))}px`);
    account.style.setProperty('--account-dialog-inline-end', `${Math.round(inlineEnd)}px`);
  }

  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account.header__icon')) return;
      positionAccountDialog(event.target);
    },
    true
  );

  window.addEventListener('resize', () => {
    document.querySelectorAll('shopify-account.header__icon').forEach(positionAccountDialog);
  });

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["movesmart-manuals"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('movesmart-manuals')) {
    customElements.define('movesmart-manuals', class extends HTMLElement {
      async connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.controller = new AbortController();
        this.form = this.querySelector('form');
        this.status = this.querySelector('[data-status]');
        this.search = this.querySelector('input[type="search"]');
        this.category = this.querySelector('[data-category-filter]');
        this.group = this.querySelector('[data-group-filter]');
        this.groups = Array.from(this.querySelectorAll('[data-category]'));
        this.status.hidden = false;
        try {
          const known = new Set(Array.from(this.querySelectorAll('[data-manual]'), node => node.dataset.manual));
          for (let page = 1; page <= Number(this.dataset.pages); page++) {
            if (page === Number(this.dataset.current)) continue;
            const url = new URL(window.location.href);
            url.hash = '';
            url.searchParams.set(this.dataset.pageParam, page);
            url.searchParams.set('section_id', this.dataset.section);
            const response = await fetch(url, { signal:this.controller.signal });
            if (!response.ok) throw new Error('Manual page unavailable');
            const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            const library = doc.querySelector('movesmart-manuals');
            if (!library || !library.querySelector('[data-manual]')) throw new Error('Manual page missing');
            library.querySelectorAll('[data-category]').forEach(category => {
              const target = this.groups.find(group => group.dataset.category === category.dataset.category);
              if (!target) throw new Error('Unknown category');
              category.querySelectorAll('[data-manual]').forEach(node => {
                if (!known.has(node.dataset.manual)) {
                  known.add(node.dataset.manual);
                  target.querySelector('ul').append(node);
                }
              });
            });
          }
          this.groups.forEach(group => {
            const list = group.querySelector('.ms-manuals__list');
            Array.from(list.children).sort((a,b) => Number(a.dataset.order)-Number(b.dataset.order) || a.textContent.localeCompare(b.textContent)).forEach(node => list.append(node));
          });
          this.items = Array.from(this.querySelectorAll('[data-manual]'));
          this.populateGroups();
          this.form.hidden = false;
          const pagination = this.querySelector('[data-pagination]');
          if (pagination) pagination.hidden = true;
          this.form.addEventListener('submit', event => event.preventDefault());
          this.search.addEventListener('input', () => this.filter());
          this.category.addEventListener('change', () => { this.populateGroups(); this.filter(); });
          this.group.addEventListener('change', () => this.filter());
          this.form.addEventListener('reset', () => { requestAnimationFrame(() => { this.populateGroups(); this.filter(); this.search.focus(); }); });
          this.querySelectorAll('.ms-manuals__jump a').forEach(link => link.addEventListener('click', () => {
            this.search.value = ''; this.category.value = ''; this.group.value = ''; this.populateGroups(); this.filter();
          }));
          this.filter();
        } catch (error) {
          if (error.name === 'AbortError') return;
          this.status.hidden = true;
          this.querySelector('[data-load-error]').hidden = false;
        }
      }
      disconnectedCallback() { this.controller?.abort(); this.initialized = false; }
      normalize(value) { return value.normalize('NFKD').replace(/[\u0300-\u036f]/g,'').toLocaleLowerCase().replace(/[^\p{L}\p{N}]+/gu,' ').trim(); }
      populateGroups() {
        const selected = this.group.value;
        const available = this.items.filter(item => !this.category.value || item.closest('[data-category]').dataset.category === this.category.value);
        this.group.options.length = 1;
        Array.from(new Set(available.map(item => item.dataset.group))).sort((a,b) => a.localeCompare(b)).forEach(value => this.group.add(new Option(value,value)));
        this.group.value = Array.from(this.group.options).some(option => option.value === selected) ? selected : '';
      }
      filter() {
        const words = this.normalize(this.search.value).split(' ').filter(Boolean);
        let count = 0;
        this.items.forEach(item => {
          const text = this.normalize(item.dataset.search + ' ' + item.textContent);
          const matches = words.every(word => text.includes(word)) && (!this.category.value || item.closest('[data-category]').dataset.category === this.category.value) && (!this.group.value || item.dataset.group === this.group.value);
          item.hidden = !matches;
          if (matches) count++;
        });
        this.groups.forEach(group => { group.hidden = !Array.from(group.querySelectorAll('[data-manual]')).some(item => !item.hidden); });
        this.status.textContent = this.dataset.countText.replace('[count]',count).replace('[total]',this.items.length);
        this.querySelector('[data-empty]').hidden = count > 0;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-comparison"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-comparison')) {
    customElements.define('product-comparison', class extends HTMLElement {
      connectedCallback() {
        this.cards = Array.from(this.querySelectorAll('[data-product-card]'));
        this.grid = this.querySelector('[data-product-grid]');
        this.count = this.querySelector('[data-result-count]');
        this.noResults = this.querySelector('[data-no-results]');
        this.tray = this.querySelector('[data-compare-tray]');
        this.dialog = this.querySelector('[data-compare-dialog]');
        this.selected = new Set();
        this.filters = {};
        this.bindEvents();
        this.selectRequestedProduct();
        this.apply();
      }

      bindEvents() {
        this.querySelectorAll('[data-preset]').forEach((button) => {
          button.addEventListener('click', () => {
            const active = button.getAttribute('aria-pressed') === 'true';
            this.querySelectorAll('[data-preset]').forEach((item) => item.setAttribute('aria-pressed', 'false'));
            button.setAttribute('aria-pressed', String(!active));
            this.filters.preset = active ? '' : button.dataset.preset;
            this.apply();
          });
        });

        this.querySelectorAll('[data-filter]').forEach((field) => {
          const eventName = field.tagName === 'SELECT' ? 'change' : 'input';
          field.addEventListener(eventName, () => {
            this.filters[field.dataset.filter] = field.value.trim().toLowerCase();
            this.apply();
          });
        });

        this.querySelector('[data-sort]')?.addEventListener('change', (event) => this.sort(event.target.value));
        this.querySelectorAll('[data-clear-filters]').forEach((button) => button.addEventListener('click', () => this.clearFilters()));
        this.querySelectorAll('[data-compare-checkbox]').forEach((checkbox) => checkbox.addEventListener('change', (event) => this.toggleSelection(event.target)));
        this.querySelector('[data-clear-selection]')?.addEventListener('click', () => this.clearSelection());
        this.querySelector('[data-open-compare]')?.addEventListener('click', () => this.openComparison());
        this.querySelector('[data-close-compare]')?.addEventListener('click', () => this.dialog?.close());
        this.dialog?.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.dialog.close();
        });
      }

      number(value) {
        if (value === undefined || value === null || value === '') return null;
        const parsed = Number(value);
        return Number.isFinite(parsed) ? parsed : null;
      }

      matches(card) {
        const weight = this.number(card.dataset.weight);
        const capacity = this.number(card.dataset.capacity);
        const width = this.number(card.dataset.width);
        const range = this.number(card.dataset.range);
        const heaviest = this.number(card.dataset.heaviest);
        const price = this.number(card.dataset.price);
        const type = card.dataset.type || '';
        const preset = this.filters.preset || '';
        const category = this.dataset.category;

        if (this.filters.type && !type.includes(this.filters.type)) return false;
        if (this.filters['weight-max'] && (weight === null || weight > Number(this.filters['weight-max']))) return false;
        if (this.filters['capacity-min'] && (capacity === null || capacity < Number(this.filters['capacity-min']))) return false;
        if (this.filters['width-max'] && (width === null || width > Number(this.filters['width-max']))) return false;
        if (this.filters['range-min'] && (range === null || range < Number(this.filters['range-min']))) return false;
        if (this.filters['heaviest-max'] && (heaviest === null || heaviest > Number(this.filters['heaviest-max']))) return false;
        if (this.filters['price-max'] && (price === null || price / 100 > Number(this.filters['price-max']))) return false;

        if (!preset) return true;
        if (preset === 'lightweight') return weight !== null && weight <= Number(this.dataset.lightweightMax || 7);
        if (preset === 'narrow') return width !== null && width <= Number(this.dataset.narrowMax || 58);
        if (preset === 'outdoor') return card.dataset.usage.includes('outdoor') || (this.number(card.dataset.wheel) || 0) >= 20;
        if (preset === 'two-in-one') return card.dataset.twoInOne === 'true';
        if (preset === 'travel') return card.dataset.transportable === 'true' || type.includes('travel') || type.includes('compact');
        if (preset === 'long-range') return range !== null && range >= Number(this.dataset.longRangeMin || 30);
        if (preset === 'full-size') return type.includes('standard') || type.includes('full-size') || type.includes('full size');
        if (preset === 'high-capacity') return capacity !== null && capacity >= Number(this.dataset.highCapacityMin || 150);
        if (preset === 'compact') return card.dataset.transportable === 'true' || type.includes('compact');
        if (preset === 'transit') return type.includes('transit');
        if (preset === 'self-propelled') return type.includes('self-propelled');
        if (preset === 'mattress') return type.includes('medical mattress');
        if (preset === 'overlay') return type.includes('overlay');
        if (preset === 'firm') return (card.dataset.title || '').toLowerCase().includes('firm') || type.includes('firm');
        if (preset === 'contoured') return type.includes('contoured');
        if (preset === 'support-pillow') return type === 'support pillow';
        if (preset === 'compact-bed') return width !== null && width <= 100;
        if (preset === 'wide-bed') return width !== null && width >= 140;
        if (preset === 'dual-motor') return card.dataset.motorCount === '2';
        if (preset === 'three-motor') return card.dataset.motorCount === '3';
        if (preset === 'compact-chair') return width !== null && width <= 85;
        return true;
      }

      selectRequestedProduct() {
        const handle = new URLSearchParams(window.location.search).get('compare');
        if (!handle) return;
        const card = this.cards.find((item) => item.dataset.handle === handle);
        const checkbox = card?.querySelector('[data-compare-checkbox]');
        if (!checkbox) return;
        checkbox.checked = true;
        this.selected.add(checkbox.value);
        this.updateTray();
        card.scrollIntoView({ block: 'center' });
      }

      apply() {
        const visible = [];
        this.cards.forEach((card) => {
          const matches = this.matches(card);
          card.hidden = !matches;
          if (matches) visible.push(card);
        });
        if (this.count) this.count.textContent = `${visible.length} ${visible.length === 1 ? 'product' : 'products'}`;
        if (this.noResults) this.noResults.hidden = visible.length !== 0;
        const hasFilters = Object.values(this.filters).some(Boolean);
        this.querySelectorAll('[data-clear-filters]').forEach((button) => {
          if (!button.closest('[data-no-results]')) button.hidden = !hasFilters;
        });
        this.updateRecommendations(visible);
      }

      clearFilters() {
        this.filters = {};
        this.querySelectorAll('[data-filter]').forEach((field) => { field.value = ''; });
        this.querySelectorAll('[data-preset]').forEach((button) => button.setAttribute('aria-pressed', 'false'));
        this.apply();
      }

      sort(value) {
        const rules = {
          'price-asc': ['price', 1],
          'price-desc': ['price', -1],
          'weight-asc': ['weight', 1],
          'width-asc': ['width', 1],
          'capacity-desc': ['capacity', -1],
          'range-desc': ['range', -1],
          'heaviest-asc': ['heaviest', 1]
        };
        const rule = rules[value];
        const sorted = [...this.cards].sort((a, b) => {
          if (!rule) return Number(a.dataset.order) - Number(b.dataset.order);
          const av = this.number(a.dataset[rule[0]]);
          const bv = this.number(b.dataset[rule[0]]);
          if (av === null && bv === null) return 0;
          if (av === null) return 1;
          if (bv === null) return -1;
          return (av - bv) * rule[1];
        });
        sorted.forEach((card) => this.grid.appendChild(card));
      }

      toggleSelection(checkbox) {
        if (checkbox.checked && this.selected.size >= 3) {
          checkbox.checked = false;
          return;
        }
        checkbox.checked ? this.selected.add(checkbox.value) : this.selected.delete(checkbox.value);
        this.updateTray();
      }

      clearSelection() {
        this.selected.clear();
        this.querySelectorAll('[data-compare-checkbox]').forEach((checkbox) => { checkbox.checked = false; });
        this.updateTray();
      }

      updateTray() {
        const size = this.selected.size;
        this.tray.hidden = size === 0;
        this.querySelector('[data-selection-count]').textContent = `${size} of 3 selected`;
        this.querySelector('[data-open-compare]').disabled = size < 2;
        this.querySelectorAll('[data-compare-checkbox]').forEach((checkbox) => {
          checkbox.disabled = size >= 3 && !checkbox.checked;
        });
      }

      updateRecommendations(cards) {
        const section = this.querySelector('[data-recommendations-section]');
        const container = this.querySelector('[data-recommendations]');
        if (!section || !container || !cards.length) return;
        const candidates = [];
        const pick = (key, direction) => cards
          .map((card) => ({ card, value: this.number(card.dataset[key]) }))
          .filter((item) => item.value !== null)
          .sort((a, b) => (a.value - b.value) * direction)[0];
        const scooterComparison = this.dataset.category === 'mobility_scooters';
        const lightest = pick(scooterComparison ? 'heaviest' : 'weight', 1);
        const narrowest = pick('width', 1);
        const strongest = pick('capacity', -1);
        const longestRange = pick('range', -1);
        if (lightest) candidates.push({ title: scooterComparison ? this.dataset.liftingStandout : 'Lightest option shown', item: lightest, unit: 'kg' });
        if (narrowest && this.dataset.category !== 'mattresses') candidates.push({ title: 'Narrowest option shown', item: narrowest, unit: 'cm wide' });
        if (strongest) candidates.push({ title: 'Highest user capacity shown', item: strongest, unit: 'kg capacity' });
        if (longestRange && (this.dataset.category === 'mobility_scooters' || this.dataset.category === 'powerchairs')) candidates.push({ title: 'Longest stated range shown', item: longestRange, unit: 'km' });
        container.innerHTML = candidates.slice(0, 3).map(({ title, item, unit }) => `
          <article class="pc-recommendation">
            <h3>${title}</h3>
            <p><a href="${item.card.dataset.url}">${item.card.dataset.title}</a> — ${item.value} ${unit}.</p>
          </article>
        `).join('');
        section.hidden = candidates.length === 0;
      }

      openComparison() {
        const selectedCards = this.cards.filter((card) => this.selected.has(card.dataset.productId));
        if (selectedCards.length < 2 || !this.dialog) return;
        const rows = new Map();
        selectedCards.forEach((card) => {
          card.querySelectorAll('[data-spec-row]').forEach((row) => {
            const key = row.dataset.key;
            if (!rows.has(key)) rows.set(key, { label: row.querySelector('dt').textContent.trim(), values: [] });
          });
        });
        rows.forEach((row, key) => {
          row.values = selectedCards.map((card) => card.querySelector(`[data-spec-row][data-key="${key}"] dd`)?.textContent.trim() || '—');
        });
        const heads = selectedCards.map((card) => {
          const image = card.querySelector('.pc-card__image img');
          return `<th scope="col"><div class="pc-table__product">${image ? `<img src="${image.currentSrc || image.src}" alt="">` : ''}<a href="${card.dataset.url}">${card.dataset.title}</a><span>${card.dataset.priceDisplay}</span></div></th>`;
        }).join('');
        const body = Array.from(rows.values()).filter((row) => row.values.some((value) => value !== '—')).map((row) => `
          <tr><th scope="row">${row.label}</th>${row.values.map((value) => `<td>${value}</td>`).join('')}</tr>
        `).join('');
        this.querySelector('[data-comparison-table]').innerHTML = `<table class="pc-table"><thead><tr><th scope="col">Specification</th>${heads}</tr></thead><tbody><tr><th scope="row">Price</th>${selectedCards.map((card) => `<td>${card.dataset.priceDisplay}</td>`).join('')}</tr>${body}<tr><th scope="row"></th>${selectedCards.map((card) => `<td><a class="button button--secondary" href="${card.dataset.url}">View product</a></td>`).join('')}</tr></tbody></table>`;
        this.dialog.showModal();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
